import { CheckCircle2, Zap, Lock } from 'lucide-react';

const FeatureItem = ({ text }) => (
  <li className="flex items-start gap-2.5">
    <CheckCircle2 className="w-4 h-4 text-[#84CC16] mt-0.5 flex-shrink-0" />
    <span className="text-sm text-[#64748B]">{text}</span>
  </li>
);

const KeyBadge = ({ label }) => (
  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-[#014DB7]/5 text-[#014DB7] text-xs font-medium rounded-lg">
    <Lock className="w-3 h-3" />
    {label}
  </span>
);

const FeatureList = ({ items }) => (
  <ul className="space-y-2">
    {items.map((f, i) => <FeatureItem key={i} text={f} />)}
  </ul>
);

const KeysList = ({ items }) => (
  <div className="flex flex-wrap gap-2">
    {items.map((k, i) => <KeyBadge key={i} label={k} />)}
  </div>
);

export const ClearinghouseCard = ({ item }) => (
  <div className="bg-white rounded-3xl border-2 border-gray-100 hover:border-[#014DB7]/30 p-8 transition-all duration-300 hover:shadow-xl group">
    <div className="flex items-start gap-5 mb-6">
      <div className="w-16 h-16 text-xl rounded-2xl flex items-center justify-center font-extrabold text-white flex-shrink-0 shadow-md" style={{ backgroundColor: item.color }}>
        {item.initials}
      </div>
      <div>
        <h3 className="text-2xl font-bold text-[#0A1628]">{item.name}</h3>
        <p className="text-[#014DB7] font-semibold text-sm">{item.tagline}</p>
        <span className="inline-flex items-center gap-1.5 mt-2 px-3 py-1 bg-[#84CC16]/10 text-[#65a30d] text-xs font-bold rounded-full">
          <Zap className="w-3 h-3" />
          {item.status}
        </span>
      </div>
    </div>
    <p className="text-[#64748B] leading-relaxed mb-6">{item.description}</p>
    <div className="mb-6">
      <h4 className="text-sm font-bold text-[#0A1628] uppercase tracking-wider mb-3">Capabilities</h4>
      <FeatureList items={item.features} />
    </div>
    <div className="pt-5 border-t border-gray-100">
      <h4 className="text-sm font-bold text-[#0A1628] uppercase tracking-wider mb-2">Keys Required</h4>
      <KeysList items={item.keysNeeded} />
    </div>
  </div>
);
